module.exports = __webpack_public_path__ + "static/img/FullBodyXRAY1.7df6e720.jpg";